import { ParagraphPlaceholder, ParagraphPlaceholderProps } from 'src/components/paragraph-placeholder';
import { defaultParagraphPlaceholderStyles } from 'src/components/paragraph-placeholder/default-paragraph-placeholder-styles';
import { withUpdatedTheme } from 'src/components/theme';
import { spacing1, spacing2 } from 'src/styles/spacing';

export const StyledContentPlaceholder = withUpdatedTheme<ParagraphPlaceholderProps>({
  paragraphPlaceholder: {
    ...defaultParagraphPlaceholderStyles,
    container: {
      ...defaultParagraphPlaceholderStyles.container,
      centeredOnMobile: true,
    },
    title: {
      ...defaultParagraphPlaceholderStyles.title,
      marginBottom: spacing2,
    },
    paragraph: {
      ...defaultParagraphPlaceholderStyles.paragraph,
      spaceBetweenLines: spacing1,
      width: '372px',
    },
  },
})(ParagraphPlaceholder);
